const dateKeyAliases = {
  y: "year",
  m: "month",
  d: "day",
  H: "hour",
  M: "minute"
};
const geoKeyAliasMap = {
  lat: "latitude",
  lon: "longitude",
  lng: "longitude"
};
const textKeyAliasMap = {
  street: "road"
};
const keyAliasMap = {
  ...dateKeyAliases,
  ...geoKeyAliasMap,
  ...textKeyAliasMap
};
export {
  dateKeyAliases,
  geoKeyAliasMap,
  keyAliasMap,
  textKeyAliasMap
};
//# sourceMappingURL=ast-aliases.js.map
